import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';

/** In-app header with back button, title and optional actions. */
export default function TopBar({ title, backTo, onBack, actions, bordered = false, transparent = false, hideBack = false }) {
  const navigate = useNavigate();
  const goBack = () => {
    if (onBack) return onBack();
    if (backTo) return navigate(backTo);
    return window.history.length > 1 ? navigate(-1) : navigate('/');
  };
  const cls = ['topbar', bordered && 'topbar--bordered', transparent && 'topbar--transparent'].filter(Boolean).join(' ');
  return (
    <header className={cls}>
      {!hideBack && (
        <button type="button" className="icon-btn" onClick={goBack} aria-label="Back">
          <IconChevronLeft size={24} />
        </button>
      )}
      {title && <h1 className="topbar__title">{title}</h1>}
      {actions && <div className="topbar__actions">{actions}</div>}
    </header>
  );
}
